<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <ez-input v-model="item.title" :error="errors['title']" required="true" helpText="a-z, A-Z, 0-9, () and space">Title</ez-input>
      </div>
      <div class="col-10 col-md-5">
        <ez-input v-model="item.link" :error="errors['link']" :placeholder="linkify" helpText="This can be used to shorten the url. example.com/{link}">Link</ez-input>
      </div>
      <div class="col-2 col-md-1">
        <ez-toggle v-model="item.active" :error="errors['active']">Active</ez-toggle>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <ez-input v-model="item.description" required="true" :error="errors['description']">Description</ez-input>
      </div>
      <div class="col-md-6">
        <ez-input v-model="item.keywords" :error="errors['keywords']">Keywords</ez-input>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label>Body</label>
        <markdown-editor v-model="item.body" :configs="configs"></markdown-editor>
      </div>
    </div>
  </div>
</template>

<script>
import markdownEditor from "vue-simplemde/src/markdown-editor";
import EzToggle from "../shared/_VueEzToggle.vue";
import EzInput from "../shared/_VueEzInput.vue";

import embers from "@/plugins/embers.js";

export default {
  name: "page-form",
  components: {
    EzToggle,
    EzInput,
    markdownEditor
  },
  props: ["item", "errors"],
  data() {
    return {
      configs: {
        previewRender: function(plainText) {
          return embers.markdownIt(plainText); // Returns HTML from a custom parser
        }
      }
    };
  },
  watch: {
    "item.title": "cleaner"
  },
  computed: {
    linkify() {
      if (this.item.title)
        return this.item.title.toLowerCase().replace(/ /g, "-");
    }
  },
  methods: {
    cleaner() {
      if (this.item.title)
        this.item.title = this.item.title.replace(
          /(_|\+|-|\.|,|!|@|#|\$|%|\^|&|\*|;|\\|\/|\||<|>|"|')+/g,
          ""
        );
    }
  }
};
</script>
